import { p as palette } from '../base/color-DMp1DFwP.js';

/* eslint-disable import/prefer-default-export */
const splitButton = {
  innerBorderRadius: '100px',
  default: {
    dropdown: {
      color: palette.gray[700],
      hoverColor: palette.squidInk,
      disabledColor: palette.gray[500]
    }
  },
  primary: {
    dropdown: {
      color: palette.white,
      hoverColor: palette.white,
      disabledColor: palette.gray[500]
    }
  }
};

export { splitButton as s };
//# sourceMappingURL=splitButton-pw-eLS1y.js.map
